import styles from './Chart.module.scss';
import {Image} from '../../../../components/Image/Image'
export const Chart = ({content})=>{
  if(!content) return
  const {title,image} = content;
  return (
    <div className={styles.wrapper}>
      {title && <div className={styles.title}>{title}</div> }
      {image && <Image src={image} className={styles.image}/>}
    </div>
  )
}